let api = '';

let module = {
	init: function (url) {
		api = url;
	},
	queryString: {
		getObject: function (delimiter) {

			var queryString;
			var query = {};
			var key;
			var val;
			var i;

			if (typeof delimiter !== 'string' || delimiter.length === 0) {
				delimiter = null;
			}

			queryString = document.location.search.substr(1).split('&');

			for (i = 0; i < queryString.length; i++) {
				queryString[i] = queryString[i].split('=');

				if (queryString[i].length > 1) {
					key = decodeURIComponent(queryString[i][0]);
					val = decodeURIComponent(queryString[i][1]);

					if (val.indexOf(delimiter) !== -1) {
						val = val.split(delimiter);
						val = val.filter(function (el) { return el !== ''; });
					}

					if (query[key]) {

						if (Array.isArray(query[key]) === false) {
							query[key] = [query[key]];
						}

						if (Array.isArray(val)) {
							query[key] = query[key].concat(val);
						} else {
							query[key].push(val);
						}

					} else {
						query[key] = val;
					}
				}
			}

			return query;
		},
		getString: function (query) {

			const entries = [];

			if (query.other?.length) {

				const other = JSON.parse(JSON.stringify(query.other));

				delete query.other;

				if (other) {
					other.forEach((item) => {

						query[item.key] = true;

					});
				}
			}

			for (const [key, values] of Object.entries(query)) {
				if (Array.isArray(values)) {
					for (const value of values) {
						entries.push([key, value]);
					}
				} else {
					if (values !== null) {
						entries.push([key, values]);
					}
				}
			}

			const queryString = entries
				.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
				.join('&');

			return `?${queryString}`;
		},
	},
	apply: async function (state, applyHistory) {

		let clean = module.cleanState(state);
		let query = module.queryString.getString(clean);
		let path = window.location.pathname;
		let url = `${api}${query}`;

		let response = await fetch(url);
		let result = await response.json();

		if (applyHistory !== false) {
			history.pushState({}, '', `${path}${query}`);
		}

		return result;
	},
	cleanState: function (state) {
		let temp = {};

		for (let key in state) {
			if (state[key] !== 0) {
				temp[key] = state[key];
			}
		}

		return temp;
	},
	getFilterState: function () {

		let base = {
			query: '',
			region: '',
			suburbs: [], // string[]
			bedroomsFrom: '',
			bedroomsTo: '',
			bathroomsFrom: '',
			PriceFrom: '',
			PriceTo: '',
			page: 1,
			sortBy: '0',
			other: [] // { key: string, value: string }
		};

		let query = module.queryString.getObject();

		if (query.query) {
			base.query = query.query;
		}

		if (query.region) {
			base.region = query.region;
		}

		if (query.suburbs) {
			base.suburbs = query.suburbs;
			if (Array.isArray(query.suburbs) === false) {
				base.suburbs = [query.suburbs];
			}
		}

		if (query.bedroomsFrom) {
			base.bedroomsFrom = parseInt(query.bedroomsFrom);
		}

		if (query.bedroomsTo) {
			base.bedroomsTo = parseInt(query.bedroomsTo);
		}

		if (query.bathroomsFrom) {
			base.bathroomsFrom = parseInt(query.bathroomsFrom);
		}

		if (query.PriceFrom) {
			base.PriceFrom = parseInt(query.PriceFrom);
		}

		if (query.PriceTo) {
			base.PriceTo = parseInt(query.PriceTo);
		}

		if (query.sortBy) {
			base.sortBy = query.sortBy;
		}

		if (query.IsFullyFurnished) {
			base.other.push({ key: 'IsFullyFurnished', value: "Fully Furnished" });
		}

		if (query.IsPetFriendly) {
			base.other.push({ key: 'IsPetFriendly', value: "Pet Friendly" });
		}

		if (query.IsNewConstruction) {
			base.other.push({ key: 'IsNewConstruction', value: "New Construction" });
		}

		if (query.IsCarpark) {
			base.other.push({ key: 'IsCarpark', value: "Carpark Only" });
		}

		return base;
	}
};

export default module;